import React, { useState } from 'react';
import ViewReverse from '../../../components/ViewReverse';
import Text from '../../../components/Text';
import dayjs from 'dayjs';
import ViewItems from '../../../components/ViewItems';
import { cn, formatNumbers } from '../../../utils/utils';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import SarSymbol from '../../../components/SarSymbol';

const TransferView = ({ item, getContent }) => {
  const { TextWeight, direction } = dynamicfunction();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='w-full rounded-lg overflow-hidden border border-grey'>
      <ViewReverse
        className={cn(
          'items-center px-5 py-3 border-b transition-all duration-500 cursor-pointer',
          isOpen ? 'bg-primary/15 border-b-grey' : 'border-b-transparent'
        )}
        onClick={() => setIsOpen(!isOpen)}
        isReverse={false}
      >
        <Text
          dir={"ltr"}
          text={dayjs(item?.createdDate).format('DD MMMM YYYY')}
          size={fontSizes.h14}
          weight={TextWeight.medium}
          color='text-primary'
          className={'flex-1'}
        />
        <ViewItems className={'flex-1'}>
          <ViewReverse isReverse={false}>
            <Text leftSymbol={true} text={formatNumbers(item?.amount)} size={fontSizes.h14} color='text-primary' weight={TextWeight.medium} />
          </ViewReverse>
          <Text text={getContent('market_value')} color='text-text-grey' />
        </ViewItems>
      </ViewReverse>

      <div className={cn('transition-all duration-500 overflow-hidden', isOpen ? 'max-h-[500px]' : 'max-h-0')}>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('transfer_amount')} size={fontSizes.h14} className={'flex-1'} />
          <ViewReverse className={'flex-1'} isReverse={false}>
            <Text leftSymbol={true} text={formatNumbers(item?.amount)} size={fontSizes.h14} className={'flex-1'} />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('transfer_fee')} size={fontSizes.h14} className={'flex-1'} />
          <ViewReverse className={'flex-1'} isReverse={false}>
            <Text leftSymbol={true} text={formatNumbers(item?.fees)} size={fontSizes.h14} className={'flex-1'} />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('transaction_number')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.id} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('to_account')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.iban} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('currency')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={'SAR'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3 border-b border-b-grey'} isReverse={false}>
          <Text text={getContent('status')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={item?.status ?? '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
        <ViewReverse className={'items-center px-5 py-3'} isReverse={false}>
          <Text text={getContent('reason')} size={fontSizes.h14} className={'flex-1'} />
          <Text text={(item?.reasonId?.toString() === '1454' ? item?.otherReason : item?.reason) ?? '-'} size={fontSizes.h14} className={'flex-1'} />
        </ViewReverse>
      </div>
    </div>
  );
};

export default TransferView;
